<template>
    <div id="userList">
        <div class="search">
            <div class="block_box">
                <div class="p_select search_day_list" >
                    <div @mouseover="onMouseOver('start')" @mouseleave="onMouseleave('start')">
                        <el-date-picker
                                v-model="beginDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerDayOptions"
                                prefix-icon="''"
                                class="datepicker"
                                placeholder="选择开始日期">
                        </el-date-picker>
                        <i class="el-icon-date" ref="iconDateStart"></i>
                    </div>
                </div>
                <div class="p_select search_day_list" >
                    <div @mouseover="onMouseOver('end')" @mouseleave="onMouseleave('end')">
                        <el-date-picker
                                v-model="endDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerDayOptions"
                                prefix-icon="''"
                                class="datepicker"
                                placeholder="选择结束日期">
                        </el-date-picker>
                        <i class="el-icon-date" ref="iconDateEnd"></i>
                    </div>
                </div>
                <div class="p_select">
                    <el-button class="search_btn" @click="getListData">查询</el-button>
                    <el-button class="add_btn" @click="exportTableImg">导出</el-button>
                </div>
            </div>
        </div>

        <div class="table">
            <div id="export">
                <div class="title_box"><span>【LVHC重点易损件报表】轮胎、蓄电池销售日报</span></div>
                <div class="sum_list_box">
                    <div class="income_box"><span>进场台次</span><span>{{inCarNum}}</span></div>
                    <div class="income_box"><span>检测台次</span><span>{{detectNum}}</span></div>
                    <div class="income_box"><span>检测覆盖率</span><span>{{detectCoverageRate}}%</span></div>
                </div>
                <div class="item_list_box">
                    <div class="day_box"><span>{{beginDateStr}}-{{endDateStr}}</span></div>
                    <div class="position_box" v-if="tireSaleVO">
                        <div class="position_name"><span>轮胎</span></div>
                        <div class="position_list">
                            <div class="position_item"><span>目标(条)</span></div>
                            <div class="position_item"><span>{{tireSaleVO.targetNum}}</span></div>
                            <div class="position_item"><span>目标进度</span></div>
                            <div class="position_item">
                                <!--<span>{{tireSaleVO.targetProgress}}%</span>-->
                                <el-progress :text-inside="true" :stroke-width="26" :percentage="tireSaleVO.targetProgress" style="width: 80%" color="#3f6b9a"></el-progress>
                            </div>
                        </div>
                        <div class="position_list">
                            <div class="position_item"><span>实际达成（条）</span></div>
                            <div class="position_item"><span>{{tireSaleVO.dealNum}}</span></div>
                            <div class="position_item"><span>时间进度</span></div>
                            <div class="position_item">
                                <!--<span>{{tireSaleVO.timeProgress * 100}}%</span>-->
                                <el-progress :text-inside="true" :stroke-width="26" :percentage="tireSaleVO.timeProgress" style="width: 80%" color="#3f6b9a" ></el-progress>
                            </div>
                        </div>
                        <div class="position_list">
                            <div class="position_item"><span>轮胎检测台次</span></div>
                            <div class="position_item"><span>{{tireSaleVO.positionDetectNum}}</span></div>
                            <div class="position_item"><span>轮胎检测台次占比</span></div>
                            <div class="position_item"><span>{{tireSaleVO.positionDetectRate}}%</span></div>
                        </div>
                        <div class="position_list">
                            <div class="position_item"><span>轮胎项目检出数</span></div>
                            <div class="position_item"><span>{{tireSaleVO.positionItemAbnormalNum}}</span></div>
                            <div class="position_item"><span>轮胎项目成交率</span></div>
                            <div class="position_item"><span>{{tireSaleVO.positionItemDealRate}}%</span></div>
                        </div>
                        <div class="position_list">
                            <div class="position_item"><span>轮胎项目增项成交数</span></div>
                            <div class="position_item"><span>{{tireSaleVO.positionItemAdditionalDealNum}}</span></div>
                            <div class="position_item"><span>轮胎项目前置成交数</span></div>
                            <div class="position_item"><span>{{tireSaleVO.positionItemFrontDealNum}}</span></div>
                        </div>
                        <div class="position_list">
                            <div class="position_item"><span>轮胎增项成交数（条）</span></div>
                            <div class="position_item"><span>{{tireSaleVO.positionAdditionalDealNum}}</span></div>
                            <div class="position_item"><span>轮胎前置成交数（条）</span></div>
                            <div class="position_item"><span>{{tireSaleVO.positionFrontDealNum}}</span></div>
                            <div class="position_item"><span>轮胎其他成交数（条）</span></div>
                            <div class="position_item"><span>{{tireSaleVO.positionOtherDealNum}}</span></div>
                        </div>
                    </div>
                    <div class="position_box" v-if="batterySaleVO">
                        <div class="position_name"><span>蓄电池</span></div>
                        <div class="position_list">
                            <div class="position_item"><span>目标(个)</span></div>
                            <div class="position_item"><span>{{batterySaleVO.targetNum}}</span></div>
                            <div class="position_item"><span>目标进度</span></div>
                            <div class="position_item">
                                <!--<span>{{batterySaleVO.targetProgress}}%</span>-->
                                <el-progress :text-inside="true" :stroke-width="26" :percentage="batterySaleVO.targetProgress" style="width: 80%" color="#3f6b9a"></el-progress>
                            </div>
                        </div>
                        <div class="position_list">
                            <div class="position_item"><span>实际达成（个）</span></div>
                            <div class="position_item"><span>{{batterySaleVO.dealNum}}</span></div>
                            <div class="position_item"><span>时间进度</span></div>
                            <div class="position_item">
                                <el-progress :text-inside="true" :stroke-width="26" :percentage="batterySaleVO.timeProgress" style="width: 80%" color="#3f6b9a" ></el-progress>
                            </div>
                        </div>
                        <div class="position_list">
                            <div class="position_item"><span>蓄电池检测台次</span></div>
                            <div class="position_item"><span>{{batterySaleVO.positionDetectNum}}</span></div>
                            <div class="position_item"><span>蓄电池检测台次占比</span></div>
                            <div class="position_item"><span>{{batterySaleVO.positionDetectRate}}%</span></div>
                        </div>
                        <div class="position_list">
                            <div class="position_item"><span>蓄电池项目检出数</span></div>
                            <div class="position_item"><span>{{batterySaleVO.positionItemAbnormalNum}}</span></div>
                            <div class="position_item"><span>蓄电池项目成交率</span></div>
                            <div class="position_item"><span>{{batterySaleVO.positionItemDealRate}}%</span></div>
                        </div>
                        <div class="position_list">
                            <div class="position_item"><span>蓄电池项目增项成交数</span></div>
                            <div class="position_item"><span>{{batterySaleVO.positionItemAdditionalDealNum}}</span></div>
                            <div class="position_item"><span>蓄电池项目前置成交数</span></div>
                            <div class="position_item"><span>{{batterySaleVO.positionItemFrontDealNum}}</span></div>
                        </div>
                        <div class="position_list">
                            <div class="position_item"><span>蓄电池增项成交数（个）</span></div>
                            <div class="position_item"><span>{{batterySaleVO.positionAdditionalDealNum}}</span></div>
                            <div class="position_item"><span>蓄电池前置成交数（个）</span></div>
                            <div class="position_item"><span>{{batterySaleVO.positionFrontDealNum}}</span></div>
                            <div class="position_item"><span>蓄电池其他成交数（个）</span></div>
                            <div class="position_item"><span>{{batterySaleVO.positionOtherDealNum}}</span></div>
                        </div>
                    </div>
                </div>
                <div class="count_detail_box">
                    <div class="detail_name">
                        <div class="count_name"><span>SA业绩统计</span></div>
                        <div class="item_name">
                            <el-table :data="saSaleList" :cell-style="cellStyle" :header-cell-style="tableHeaderColor" style="width: 100%">
                                <el-table-column prop="saName" label="姓名" ></el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="detail_list">
                        <el-table :data="saSaleList" :cell-style="cellStyle" :header-cell-style="tableHeaderColor" style="width: 100%">
                            <el-table-column prop="saTireSaleVO.saItemAbnormalNum" label="检出项目数"></el-table-column>
                            <el-table-column prop="saTireSaleVO.saAdditionalDealNum" label="增项成交数(条)"></el-table-column>
                            <el-table-column prop="saTireSaleVO.saFrontDealNum" label="前置成交数(条)"></el-table-column>
                            <el-table-column prop="saTireSaleVO.saRank" label="排名"></el-table-column>
                            <el-table-column prop="saBatterySaleVO.saItemAbnormalNum" label="检出项目数"></el-table-column>
                            <el-table-column prop="saBatterySaleVO.saAdditionalDealNum" label="增项成交数(个)"></el-table-column>
                            <el-table-column prop="saBatterySaleVO.saFrontDealNum" label="前置成交数(个)"></el-table-column>
                            <el-table-column prop="saBatterySaleVO.saRank" label="排名"></el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="count_detail_box">
                    <div class="detail_name">
                        <div class="count_name"><span>技师业绩统计</span></div>
                        <div class="item_name">
                            <el-table :data="workerSaleList" :cell-style="cellStyle" :header-cell-style="tableHeaderColor" style="width: 100%">
                                <el-table-column prop="workerName" label="姓名" ></el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="detail_list">
                        <el-table :data="workerSaleList" :cell-style="cellStyle" :header-cell-style="tableHeaderColor" style="width: 100%">
                            <el-table-column prop="workerTireSaleVO.workerItemDetectNum" label="检测项目数"></el-table-column>
                            <el-table-column prop="workerTireSaleVO.workerItemAbnormalNum" label="检出项目数"></el-table-column>
                            <el-table-column prop="workerTireSaleVO.workerAdditionalDealNum" label="增项成交数(条)"></el-table-column>
                            <el-table-column prop="workerTireSaleVO.workerRank" label="排名"></el-table-column>
                            <el-table-column prop="workerBatterySaleVO.workerItemDetectNum" label="检测项目数"></el-table-column>
                            <el-table-column prop="workerBatterySaleVO.workerItemAbnormalNum" label="检出项目数"></el-table-column>
                            <el-table-column prop="workerBatterySaleVO.workerAdditionalDealNum" label="增项成交数(个)"></el-table-column>
                            <el-table-column prop="workerBatterySaleVO.workerRank" label="排名"></el-table-column>
                        </el-table>
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
  import moment from 'moment'
  import net from "../../assets/js/public";
  import html2canvas from 'html2canvas';
  import * as echarts from 'echarts';
  export default {
    name: "pointOptionReport",
    data() {
      return {

        beginDate:'',
        endDate:'',
        pickerDayOptions: { // 按天 当天、当月可选
          disabledDate(time) {
            return time.getTime() > Date.now() + 1 * 24 * 60 * 60 * 1000;
          }
        },

        orgId: "",
        orgArr: [], //所有集团下所有站点
        orgName:'',

        beginDateStr: '',
        endDateStr: '',
        inCarNum: 0,
        detectNum: 0,
        detectCoverageRate: 0,
        tireSaleVO: '',
        batterySaleVO: '',
        saSaleList: [],
        workerSaleList: [],
      };
    },
    created() {
      let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      if(signInfo.orgId > 0){
        this.orgId = signInfo.orgId
      }

      let obj = new Date();
      let month = obj.getMonth() + 1;
      if (month < 10) month = "0" + month;
      let day = obj.getDate();
      if (day < 10) day = "0" + day;
      // 明天
      let after = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)//后一天
      let afterMonth = after.getMonth() + 1;
      if (afterMonth < 10) afterMonth = "0" + afterMonth;
      let afterDay = after.getDate()
      if (afterDay < 10) afterDay = "0" + afterDay;

      let monthFirstDay = obj.getFullYear() + "-" + month + "-01"; //本月第一天
      let monthAfterDay = after.getFullYear() + "-" + afterMonth + "-" + afterDay; //明天

      this.beginDate = monthFirstDay
      this.endDate = monthAfterDay;
      this.getListData()

    },
    methods: {

      onMouseOver(item) {
        if(item == 'start'){
          this.$refs.iconDateStart.style.display = 'none';
        }else {
          this.$refs.iconDateEnd.style.display = 'none';
        }
      },
      onMouseleave(item) {
        if(item == 'start'){
          this.$refs.iconDateStart.style.display = 'block';
        }else {
          this.$refs.iconDateEnd.style.display = 'block';
        }
      },

      // 表头样式  日报
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return "background-color:#3f6b9a; color: #fff; text-align: center;font-size: 14px;height: 50px;font-weight: 500;border-left: 1px solid #fff;";
      },
      cellStyle({ row, column, rowIndex, columnIndex }) {
        return 'background-color:#34485d; color: #fff; font-weight: 400;border-bottom:none;text-align: center; border-left: 1px solid #fff;'
      },


      getListData(){
        const params = {
          beginDate: this.beginDate,
          endDate: this.endDate,
          orgId: this.orgId,
        }
        net.request("admin/manage/report/tireBatterySaleReport", "post", null, params).then(res => {
          if (res.code === 0){
            let data = res.data

            let beginDateStr = moment(this.beginDate).format('YYYY年MM月DD日')
            let endDateStr = moment(this.endDate).format('YYYY年MM月DD日')

            this.beginDateStr = beginDateStr
            this.endDateStr = endDateStr
            this.inCarNum = data.inCarNum
            this.detectNum = data.detectNum
            this.detectCoverageRate = data.detectCoverageRate

            this.tireSaleVO = data.tireSaleVO
            this.batterySaleVO = data.batterySaleVO
            this.saSaleList = data.saSaleList
            this.workerSaleList = data.workerSaleList

          }else {
            net.message(this, res.msg, "warning");
          }
        })
      },
      exportTableImg(){
        const exportImgHeight = document.getElementById("export").offsetHeight;
        const exportImgWidth = document.getElementById("export").offsetWidth;
        let beginDate = moment(this.beginDate).format('YYYYMMDD')
        let endDate = moment(this.endDate).format('YYYYMMDD')

        console.log(exportImgHeight,exportImgWidth)

        setTimeout(() => {
          html2canvas(document.querySelector("#export")).then(canvas => {
            var saveFile = function(data, filename) {
              var save_link = document.createElementNS( "http://www.w3.org/1999/xhtml", "a" );
              save_link.href = data;
              save_link.download = filename;
              var event = document.createEvent("MouseEvents");
              event.initMouseEvent(
                "click",
                true,
                false,
                window,
                0,
                0,
                0,
                0,
                0,
                false,
                false,
                false,
                false,
                0,
                null
              );
              save_link.dispatchEvent(event);
            };

            const img = new Image();
            img.src = canvas.toDataURL("png");
            img.setAttribute("crossOrigin", "anonymous");
            canvas = document.createElement("canvas");
            canvas.width = exportImgWidth;
            canvas.height = exportImgHeight;
            var ctx = canvas.getContext("2d");
            img.onload = function() {
              var w = img.width;
              var h = img.height;
              ctx.drawImage(img, 0, 0, w, h, 0, 0, w, h);
              var dataURL = canvas.toDataURL("image/png");
              saveFile(dataURL, beginDate+"_"+endDate+"重点易损件.png");
            };
          });
        }, 1000);
      },


    },
  };
</script>


<style lang="less" scoped>

    #userList {
        display: flex;
        flex-direction: column;
        margin: 24px 0 0 24px;
        background: #fff;
        padding-left: 12px;
        min-width: 1000px;
        .search {
            background: #fff;
            padding-top: 12px;
            margin-bottom: 12px;
            display: flex;
            .block_box{
                width: 100%;
                .p_select {
                    display: flex;
                    /*padding: 0 24px 0px 0;*/
                    font-size: 12px;
                    float: left;
                    margin-right: 12px;
                    .search_label{
                        font-family: 'PingFang SC';
                        font-style: normal;
                        margin-right: 12px;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 40px;
                        color: #787E86;
                        white-space:nowrap
                    }

                    .el-input , .el-select{
                        width: 160px;
                    }
                }
                .search_btn {
                    /*width: 76px;*/
                    /*height: 36px;*/
                    background: #2B54FC;
                    box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                    border-radius: 4px;
                    color: #FFFFFF;
                    font-size: 14px;
                }
                .add_btn {
                    /*width: 76px;*/
                    height: 36px;
                    background: rgba(148, 170, 204, 0.08);
                    border: 1px solid #2B54FC;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #2B54FC;
                }
            }
        }
        .table {
            padding-right: 24px;
        }


        #export {
            background-color: #34485d;
            width: 100%;
            color: #fff;
            .title_box {
                width: 100%;
                height: 80px;
                line-height: 80px;
                color: #fce143;
                font-size: 26px;
                border-bottom: 2px solid #fff;
            }
            .sum_list_box {
                display: flex;
                border-bottom: 1px solid #fff;
                .income_box {
                    width: 33.3%;
                    span{
                        display: block;
                        width: 100%;
                        height: 30px;
                        line-height: 30px;
                        border-bottom: 1px solid #fff;
                        border-right: 1px solid #fff;
                    }
                }
            }
            .item_list_box {
                border-bottom: 2px solid #fff;
                display: flex;
                .day_box {
                    width: 20%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-bottom: 1px solid #fff;
                }
                .position_box {
                    width: 40%;
                    border-left: 1px solid #fff;
                    .position_name {
                        width: 100%;
                        height: 35px;
                        line-height: 35px;
                        border-bottom: 1px solid #fff;
                    }
                    .position_list {
                        display: flex;
                        justify-content: space-between;
                        border-bottom: 1px solid #fff;
                        .position_item {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 100%;
                            height: 40px;
                            font-size: 13px;
                            border-right: 1px solid #fff;

                            .deal_data {
                                width: 100%;
                                height: 40px;
                            }
                        }
                    }
                }
            }
            .count_detail_box {
                display: flex;
                border-bottom: 1px solid #fff;
                justify-content: space-between;
                .detail_name {
                    width: 20%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .count_name {
                        width: 60%;
                        background-color: rgb(63, 107, 154);
                        height: 100%;
                        align-items: center;
                        display: flex;
                        justify-content: center;
                    }
                    .item_name {
                        width: 40%;
                    }
                }
                .detail_list {
                    width: 80%;
                }
            }


            .el-progress-bar__outer {
                background-color: #e0e0e0; /* 修改底色 */
            }
        }


    }
</style>
<style lang="less">
    .el-table .cell {

        white-space: pre-line;
    }
    .el-progress-bar__innerText {

        color: #000;

    }
</style>

